import React, { useEffect } from 'react';
import { ArmGlobalNavigation } from '@arm/ce-shared-components';
import config from '../../../temp/config';
import './GlobalNavigation.css';
import { UseGlobalState } from '../../../context';
import { initAzureB2CAction } from '../../../context/action/user';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { DEVELOPER_HUB_GLOBAL_NAV_APP_NAME } from '../../../constants/constants';
import { getGlobalNavAppName, isSupportApplication } from '../../../lib/ApplicationTag';
import { getPostAuthRedirectPath } from '../../../lib/msalAuthConfig';
import SupportAuth from '../SupportAuth';

const GlobalNavigation = ({ route, sitecoreContext }) => {
  const isEditorMode = sitecoreContext?.pageEditing;
  const { dispatch, user } = UseGlobalState();
  const appName = getGlobalNavAppName(route, sitecoreContext);
  const isSupport = isSupportApplication(route, sitecoreContext);
  useEffect(() => {
    if (isEditorMode || isSupport) {
      return;
    }
    initAzureB2CAction(dispatch);
  }, [dispatch, isEditorMode, isSupport]);

  return (
    <>
      <ArmGlobalNavigation
        appName={appName}
        auth={{
          user: user?.user,
          isAuthenticated: Boolean(user?.isAuth),
          menuLinks: [
            {
              label: 'Profile',
              url: config.REACT_APP_SITECORE_PROFILE_LINK,
            },
            {
              label: 'Settings',
              url: config.REACT_APP_SITECORE_SETTINGS_LINK,
            },
            {
              label: 'Notifications',
              url: config.REACT_APP_SITECORE_NOTIFICATIONS_LINK,
            },
          ],
          loginLink: isSupport
            ? '/login'
            : config.REACT_APP_ORIGIN +
              config.REACT_APP_PATHNAME +
              `user-login${
                typeof window === 'undefined' ? '' : '?returnUrl=' + window.location.pathname
              }`,
          logoutLink: isSupport
            ? '/logout'
            : config.REACT_APP_ORIGIN + config.REACT_APP_PATHNAME + 'user-logout',
          postAuthRedirectPath: isSupport ? getPostAuthRedirectPath() : undefined,
          notificationsApi: config.REACT_APP_SITECORE_NOTIFICATIONS_API,
          registerLink: '/register',
        }}
        searchUrl={`${config.REACT_APP_ORIGIN}/search#numberOfResults=48&q=`}
        isTheme={false}
        scriptEnvironmentHostUrl={config.REACT_APP_ARM_GLOBALNAVIGATION_HOST}
      />
      {isSupport && <SupportAuth />}
    </>
  );
};
const GlobalNavigationClient = () => {
  return (
    <ArmGlobalNavigation
      appName={DEVELOPER_HUB_GLOBAL_NAV_APP_NAME}
      auth={{
        menuLinks: [
          {
            label: 'Profile',
            url: config.REACT_APP_SITECORE_PROFILE_LINK,
          },
          {
            label: 'Settings',
            url: config.REACT_APP_SITECORE_SETTINGS_LINK,
          },
          {
            label: 'Notifications',
            url: config.REACT_APP_SITECORE_NOTIFICATIONS_LINK,
          },
        ],
        loginLink: `user-login?returnUrl=${window.location.pathname}`,
        registerLink: '/register',
        logoutLink: '/user-logout',
      }}
      searchUrl={`${config.REACT_APP_ORIGIN}/search#numberOfResults=48&q=`}
      isTheme={false}
      scriptEnvironmentHostUrl={config.REACT_APP_ARM_GLOBALNAVIGATION_HOST}
    />
  );
};

export default withSitecoreContext()(GlobalNavigation);
export { GlobalNavigationClient };
